<div *ngIf="region == 'APAC'; else NotApacBlock">
    <div *ngIf="enableHyperlink"><a href="javascript:void(0)" (click)="onLinkClick($event)">Modify PA</a></div>
    <div *ngIf="!enableHyperlink">Modify PA</div>
</div>
<ng-template #NotApacBlock>
    <div><a href="javascript:void(0)" (click)="onLinkClick($event)">Modify PA</a></div>
</ng-template>